import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {

  }

  get isChecked(): boolean
  {
    if(!this.attribute.value) {
      return false;
    }

    return this.attribute.value.toLowerCase() == "true";
  }

  set value(checked: boolean)
  {
      this.attribute.value = String(checked);
  }

  getValue(): string {
    if(this.attribute.value) {
      return this.attribute.value.toLowerCase() == 'true' ? 'Sim' : 'Não'
    }

    return "Não"
  }

  onValueChange(value: any) {
    this.attribute.value = null;
    this.attribute.value = value.target.checked.toString();

    let events: DynamicEvent[] = []

    events.push({ name: "changed", attribute: this.attribute})
    events.push({ name: "autosave", data: "silently" })

    this.emitEvents(events)
  }


}
